/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/

import { THREE } from 'expo-three'
import React, { useRef, useEffect, useState } from 'react'
import { useFrame } from '@react-three/fiber'
import { useApi, useCircle } from '../../systems/Physics/hooks'
import useCollision from '../../hooks/useCollision'
import { useEvents } from '../../systems/World/hooks'
import { CHARACTER_EVENTS } from '../../systems/World/Events'

import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'

import modelObj from '../../../assets/crystals/detail_crystal.obj'
import modelMtl from '../../../assets/crystals/detail_crystal.mtl'

const loaderObj = new OBJLoader();
const loaderMtl = new MTLLoader();

const COLORS_BY_TYPE = {
  grow: 0x006600,
  coil: 0x2a4db5,
  freezer: 0x99ccff,
}

function hide(ref) {
  if (ref.current.visible) {
    ref.current.visible = false
  }
}
function show(ref) {
  if (!ref.current.visible) {
    ref.current.visible = true
  }
}

const Model = props => {
  const { type, timeToAppear, ...passProps } = props
  const [step, setStep] = useState('HIDDEN')
  const ref = useRef()
  const circleRef = useRef()
  const [geometry, setGeometry] = useState()
  const [baseRef] = useCircle({}, ref)
  const api = useApi()
  const triggerOnPickCoil = useEvents(CHARACTER_EVENTS.PICK_CRYSTAL_COIL)
  const triggerOnPickFreezer = useEvents(CHARACTER_EVENTS.PICK_CRYSTAL_FREEZER)
  const triggerOnPickGrow = useEvents(CHARACTER_EVENTS.PICK_CRYSTAL_GROW)
  const triggerOnOvercharge = useEvents(CHARACTER_EVENTS.OVERCHARGE)
  
  useCollision(collidedFixture => {
    if (step === 'AVAILABLE') {
      setStep('PICKED')
      const uuid = collidedFixture.GetBody().GetUserData().uuid
      if (type === 'grow') {
        api.grow(uuid)
        triggerOnPickGrow(uuid)
      }
      if (type === 'coil') {
        api.overchargePower(uuid)
        triggerOnPickCoil(uuid)
        triggerOnOvercharge(uuid)
      }
      if (type === 'freezer') {
        api.overchargeFreezer(uuid)
        triggerOnPickFreezer(uuid)
        triggerOnOvercharge(uuid)
      }
    }
  }, baseRef.current?.uuid)
  
  // change pink by green
  let colorMaterial = new THREE.MeshLambertMaterial({ color: COLORS_BY_TYPE[type] })

  const loadObject = async () => {
    const mtl = loaderMtl.parse(modelMtl)
    mtl.preload();
    loaderObj.setMaterials(mtl)
    const obj = loaderObj.parse(modelObj)
    obj.children[0].material = colorMaterial

    obj.children[0].castShadow = true
    setGeometry(obj)
  }

  useEffect(loadObject,[])

  useEffect(() => {
    setTimeout(() => {
      setStep('APPROACHING')
    }, timeToAppear);
  },[])
  
  function animationLoop() {
    switch (step) {
      case 'HIDDEN':
        hide(circleRef)
        hide(baseRef)
        break
      case 'APPROACHING':
        show(circleRef)
        if (circleRef.current.scale.x > 0) {
          circleRef.current.scale.x = circleRef.current.scale.y = circleRef.current.scale.z -= 0.005
        } else {
          setStep('AVAILABLE')
        }
        break
      case 'AVAILABLE':
        hide(circleRef)
        show(baseRef)
        break
      case 'PICKED':
        hide(baseRef)
        break
      default:
        break
    }
  }
  useFrame(() => {
    if (circleRef.current) {
      animationLoop()
    }
  })
  
  return (
    <>
      <group
        ref={circleRef}
        position={passProps.position}
      >
        <mesh
          rotation={[-Math.PI/2, 0, 0]}
          geometry={new THREE.RingGeometry(14.99, 15, 62)}
          material={new THREE.LineBasicMaterial({ color: 0xffff00 })}
        />
      </group>
      <group
        ref={baseRef}
        visible={false}
        // position={[0, 0.21, 0]}
        {...passProps}
        dispose={null}
        userData={{
          radius: 0.25,
          pickable: true,
          originPosition: [0, 0.25, 0],
        }}
      >
        {geometry &&
          <primitive object={geometry} />
        }
        {/* <mesh
          castShadow
          material={colorMaterial}
          geometry={nodes.detail_crystal.geometry}
        /> */}
      </group>
    </>
  )
}

export default Model